export default __webpack_public_path__ + "static/media/payment-screen1.64e553c6.mp4";